module.exports = __webpack_public_path__ + "img/Talroo.7222c6a0.png";